import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useCheckboxStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  /** Figma-aligned row: tighter vertical spacing, label aligned to control top. */
  figmaRoot: {
    alignItems: 'flex-start',
    columnGap: tokens.spacingHorizontalS,
  },
  requiredAsterisk: {
    color: tokens.colorPaletteRedForeground1,
    marginLeft: tokens.spacingHorizontalXXS,
  },
  highlightedContainer: {
    backgroundColor: tokens.colorPaletteYellowBackground1,
    ...shorthands.border('1px', 'solid', tokens.colorPaletteYellowBorder1),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
    ...shorthands.padding(tokens.spacingHorizontalS),
  },
  /** Figma-aligned policy confirmation container (green-tinted). */
  figmaPolicyConfirm: {
    backgroundColor: tokens.colorPaletteGreenBackground1,
    color: tokens.colorPaletteGreenForeground1,
    ...shorthands.border('1px', 'solid', tokens.colorNeutralStroke1),
    ...shorthands.borderRadius('0.5rem'),
    ...shorthands.padding(tokens.spacingHorizontalM),
  },
});
